module.exports = __webpack_public_path__ + "img/kort-26.86b62c4e.jpg";